import { observer } from "mobx-react-lite";
import { ToggleGroup, View, XStack, YStack } from "tamagui";
import { ModuleDoneType } from "../../../templates/types";
import { ToggleGroupItem } from "../../core/components/ToggleGroupItem";
import { getQuestionForTemplateAndModule } from "../../templates/useCreatePlanFromTemplate";
import { Body } from "../../ui/Body";
import { Label } from "../../ui/Label";
import { ModuleIcon } from "../../ui/ModuleIcon";
import type { BaseModuleType } from "./BaseModuleModel";

export const ModuleOnboardingBlock = observer(
  ({ module }: { module: BaseModuleType }) => {
    const question = getQuestionForTemplateAndModule(
      module.plan.data.template,
      module.data.type,
    );

    return (
      <XStack
        key={module.uid}
        justifyContent="space-between"
        gap="$small"
        width={"100%"}
      >
        <View alignItems="center" width={"$size.medium"} marginTop={2}>
          <ModuleIcon key={`${module.data.emoji}`} module={module} />
        </View>
        <YStack gap="$small" flex={1} marginLeft="$small">
          <Label>{question}</Label>
        </YStack>
        <ToggleGroup
          flexShrink={0}
          type="single"
          onValueChange={async (value) => {
            console.info("got value", value);

            await module.setDoneType(
              value === "true" ? ModuleDoneType.Static : ModuleDoneType.Voting,
            );
          }}
          disablePassBorderRadius
          padding={1}
          alignSelf="center"
        >
          <ToggleGroupItem value={"true"}>
            <Body>Yes</Body>
          </ToggleGroupItem>
          <ToggleGroupItem value={"false"}>
            <Body>No</Body>
          </ToggleGroupItem>
        </ToggleGroup>
      </XStack>
    );
  },
);
